<template lang="pug">
  v-dialog(max-width='500px' v-model='mode.sectionDialog' persistent scrollable transition='dialog-left-transition')
    v-card
      v-card-title.headline.grey.lighten-2.pa-1(primary-title) {{formTitle(&apos;Section&apos;)}}
      v-card-text.pa-1
        v-alert(v-model='showAlert' dismissible type='error') {{alertMessage}}
        v-form.pa-1(ref='section')
          v-form-base#sectionForm(:value='editedItem' :schema='schema' @input:sectionForm='onFormInput')
            | Layout
            floor-plan(slot='slot-item-key-tables' :tables='editedItem.tables' :options="{mode:'edit'}" @alert='alertMessage=$event;showAlert=true')
            user-selector(slot='slot-item-key-_supervisorId' label='Supervisor' :context="{selectedId:editedItem._supervisorId, users:users.filter(u=>u.roles.includes('SS'))}" v-on:change='supervisorChanged($event)')
            user-selector(slot='slot-item-key-_waiterId' label='Waiter' :context="{selectedId:editedItem._waiterId, users:users.filter(u=>u.roles.includes('SW'))}" v-on:change='waiterChanged($event)')
            user-selector(slot='slot-item-key-_helperId' label='Helper' :context="{selectedId:editedItem._helperId, users:users.filter(u=>u.roles.includes('SH'))}" v-on:change='helperChanged($event)')
      v-divider
      v-card-actions
        v-btn(color='primary' v-if='editedItem.id && editedItem.status === STATUSES.ACTIVE' :disabled='isDirty' text v-on:click.stop='deActivate(dialogKey)') De-Activate
        v-btn(color='primary' v-if='editedItem.id && editedItem.status === STATUSES.INACTIVE' :disabled='isDirty' text v-on:click.stop='editedItem.status=STATUSES.ACTIVE;save(dialogKey)') Activate
        v-spacer
        v-btn(color='primary' v-if='isDirty' text v-on:click.stop='clearActiveItems();cancel(dialogKey)') Cancel
        v-btn(color='primary' v-if='!isDirty' text v-on:click.stop='clearActiveItems();cancel(dialogKey)') Close
        v-btn(color='primary' :disabled='!isDirty' text v-on:click.stop='clearActiveItems();save(dialogKey)') Save
</template>

<script>
import { storeMixin } from "../../mixins/storeMixin.js";
import { dialogsMixin } from "../../mixins/dialogsMixin.js";

export default {
  name: "section-dialog",
  mixins: [storeMixin, dialogsMixin],
  beforeMount() {
    if (!this.editedItem.id) {
      Object.assign(this.editedItem, this.defaultItem);
    }
  },
  data() {
    return {
      collectionName: "sections",
      dialogKey: "sectionDialog",
      defaultItem: {
        name: "",
        tables: [],
        _supervisorId: "",
        _waiterId: "",
        _helperId: "",
        supervisorName: "",
        waiterName: "",
        helperName: "",
        notes: "",
        status: 0
      },
      showAlert: false,
      alertMessage: ""
    };
  },
  computed: {
    schema() {
      return Object.assign(
        {
          _groupKey: { type: "text", hidden: true },
          _restaurantKey: { type: "text", hidden: true },
          code: {
            type: "text",
            label: "Code",
            flex: 2,
            sort: 1,
            rules: [
              this.required("Section Code is required"),
              this.minLen(2),
              this.maxLen(8)
            ],
            disabled: true
          },
          name: {
            type: "text",
            label: "Name",
            flex: 9,
            offset: 1,
            sort: 2,
            rules: [
              this.required("Section Name is required"),
              this.minLen(10),
              this.maxLen(40)
            ]
          },
          tables: { type: "text", sort: 3, flex: 12, hidden: false },
          _supervisorId: {
            type: "text",
            sort: 4,
            flex: 12,
            hidden: !this.myFeatures.eligibleFeatures.includes("WORKFLOW")
          },
          _waiterId: {
            type: "text",
            sort: 5,
            flex: 12,
            hidden: !this.myFeatures.eligibleFeatures.includes("WORKFLOW")
          },
          _helperId: {
            type: "text",
            sort: 6,
            flex: 12,
            hidden: !this.myFeatures.eligibleFeatures.includes("WORKFLOW")
          },
          supervisorName: { type: "text", sort: 5, flex: 12, hidden: true },
          waiterName: { type: "text", sort: 5, flex: 12, hidden: true },
          helperName: { type: "text", sort: 5, flex: 12, hidden: true },
          status: {
            type: "select",
            label: "Status",
            items: ["Draft", "Active", "Open", "Closed", "Inactive"],
            flex: 3,
            sort: 7,
            rules: [this.required("Status is required")],
            hidden: true
          },
          notes: {
            type: "textarea",
            label: "Notes",
            flex: 12,
            sort: 8,
            rules: [this.maxLen(200)]
          }
        },
        this.baseSchema
      );
    }
  },
  methods: {
    supervisorChanged(user) {
      this.editedItem._supervisorId = user ? user.id : null;
      this.editedItem.supervisorName = user ? user.fullName : null;
      this.isDirty = true;
    },
    waiterChanged(user) {
      this.editedItem._waiterId = user ? user.id : null;
      this.editedItem.waiterName = user ? user.fullName : null;
      this.isDirty = true;
    },
    helperChanged(user) {
      this.editedItem._helperId = user ? user.id : null;
      this.editedItem.helperName = user ? user.fullName : null;
      this.isDirty = true;
    },
    clearActiveItems() {
      this.editedItem.tables.forEach(t => {
        t.active = false;
        t.seats.forEach(s => {
          s.active = false;
        });
      });
    }
  },
  watch: {
    editedItem: {
      handler: function() {
        this.isDirty = true;
      },
      deep: true
    }
  }
};
</script>